<template>
  <div>
    <PageContent
      :dataList="packing"
      title="智能监测"
      ref="pageContentRef"
    >
      <div class="circulation">
        <!-- <div class="title">流通信息</div> -->
        <div class="item-wrap">
          <div class="left">
            <div class="tle">土壤监测WLW000001</div>
            <div class="item">
              <!-- {{ options.business.bussinessName  }} -->
              土壤温度: <span>一</span>
            </div>
            <div class="item">
              <!--{{ options.business.addressDetail  }} -->
              土壤湿度: <span>一</span>
            </div>
            <div class="item">
              <!--{{ options.business.phone  }} -->
              光照：<span>一</span>
            </div>
            <div class="item">
              <!--{{ options.business.phone  }} -->
              二氧化碳浓度：<span>一</span>
            </div>
            <div class="item">
              <!--{{ options.business.phone  }} -->
              气体浓度：<span>一</span>
            </div>
            <div class="item">
              <!--{{ options.business.phone  }} -->
              土壤容积含水率: <span>一</span>
            </div>
          </div>
         
          <!-- <div class="left">
        <div class="tle">当前经销商 </div>
        <div class="item">名称: <span> </span></div>
        <div class="item">地址: <span></span></div>
        <div class="item">联系电话: <span> </span></div>
      </div> -->
        </div>
      </div>
    </PageContent>
  </div>
</template>
<script>
import Vue from "vue";

import { Toast } from "vant";

Vue.use(Toast);
export default {
  mounted() {
  
  },
  data() {
    return {
      packing: {
        msgItems: [
          {
            txid: "06dafb626f3041587360c91b0d98569d13f21d3a98a66e97e91c115ed32990c2273",
            ts: 1622177313286,
            op: {
              op: {},
            },
          },
          {
            txid: "06dafb626f3041587360c91b0d98569d13f21d3a98a66e97e9454",
            ts: 1632177383300,
            op: {
              op: {},
            },
          },
        ],
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.circulation {
  padding: 0 40px;
  .item-wrap {
    .left {
      position: relative;
      margin-bottom: 32px;
      padding-left: 40px;
      border-left: 5px solid #26907a;
      &::before {
        content: "";
        position: absolute;
        top: 20px;
        left: -3px;
        transform: translateX(-50%);
        width: 28px;
        height: 28px;
        background: #ffffff;
        border: 5px solid #26907a;
        border-radius: 50%;
      }
      &:first-child {
        .tle {
          // background-color: rgb(43, 41, 41);
          top: -10px;
        }
      }
      &:first-child::before {
        content: "";
        position: absolute;
        top: 0;
        left: -3px;
        transform: translateX(-50%);
        width: 28px;
        height: 28px;
        background: #ffffff;
        border: 5px solid #26907a;
        border-radius: 50%;
      }
      .tle {
        position: relative;
        top: 5px;
        padding: 14px 32px;
        box-sizing: border-box;
        text-align: center;
        display: inline-block;
        background-color: #26907a;
        font-size: 28px;
        color: #fff;
        border-radius: 16px;
        &::before {
          position: absolute;
          top: 50%;
          left: -12px;
          transform: translateY(-50%);
          content: "";
          width: 12px;
          height: 8px;
          background: #26907a;
        }
      }
      .first {
        top: -14px;
      }
      .item {
        margin-top: 20px;
        // background-color: pink;
        margin-bottom: 16px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 38px;
        color: #222222;
        span {
          font-size: 28px;
          color: #808080;
        }
      }
    }
  }
}
.enterPriseInfo {
  .item {
    // margin-bottom: 54px;
    margin-top: 20px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    color: #222222;
    .item-icon {
      width: 8px;
      height: 8px;
      background-color: #26907a;
      margin-right: 16px;
    }
    span.title-item {
      color: #222222;
      font-size: 28px;
      font-weight: bold;
    }
    img {
      float: right;
      width: 40px;
      height: 40px;
    }
  }
}
</style>